import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "text"]

  copy(event) {
    event.preventDefault()
    
    const textToCopy = this.sourceTarget.innerText || this.sourceTarget.textContent
    navigator.clipboard.writeText(textToCopy).then(() => {
      if (this.hasTextTarget) {
        const originalText = this.textTarget.innerText
        this.textTarget.innerText = "Copied!"
        
        setTimeout(() => {
          this.textTarget.innerText = originalText
        }, 2000)
      }
    }).catch(err => {
      console.error("Failed to copy text: ", err)
    })
  }
}
